import { useState, useRef, useEffect, useCallback } from "react";
import logo from "./assets/logo.png";
import logo1 from "./assets/ll.png";
import img from "./assets/JAFAR-1.png";
import jf from "./assets/jf.png";
import talk from "./assets/kk.png";
import tn from "./assets/tn.png";
import { useAuth } from "../Auth/AuthContext";
import './css/style.css';
import imgg1 from "./assets/1.png";
import imgg2 from "./assets/2.png";
import imgg3 from "./assets/3.png";
import imgg4 from "./assets/4.png";
import { motion } from "framer-motion";
import { addDoc, collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { db } from "../Admin/Config/Config";
import { StarIcon } from "lucide-react";
import { FaWhatsapp } from 'react-icons/fa';
import ReactPlayer from "react-player";
import Toast from "../Toast/Toast";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { triggerLoginPopup } = useAuth();
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [messageContent, setMessageContent] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [toastContent, setToastContent] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // setIsCoursesOpen(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.closest('[aria-controls="mobile-menu"]')
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [activeIndex, setActiveIndex] = useState(2);
  const [autoPlay, setAutoPlay] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const scrollContainerRef = useRef(null);
  const itemsRef = useRef([]);
  const timeoutRef = useRef(null);
  const activeIndexRef = useRef(activeIndex);
  const [videoList, setVideoList] = useState([]);


  useEffect(() => {
    activeIndexRef.current = activeIndex;
  }, [activeIndex]);

  const scrollToIndex = useCallback((index) => {
    const container = scrollContainerRef.current;
    const item = itemsRef.current[index];
    if (item) {
      const scrollTo =
        item.offsetLeft - (container.clientWidth - item.clientWidth) / 2;
      container.scrollTo({ left: scrollTo, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    if (autoPlay&& videoList.length > 0) {
      timeoutRef.current = setInterval(() => {
        const nextIndex = (activeIndexRef.current + 1) % videoList.length;
        setActiveIndex(nextIndex);
        scrollToIndex(nextIndex);
      }, 3000);
    }
    return () => clearInterval(timeoutRef.current);
  }, [autoPlay, scrollToIndex, videoList]);

  const handleThumbnailClick = (video) => {
    setCurrentVideo(video);
    setModalOpen(true);
  };



  const [counts, setCounts] = useState({
    successRate: 0,
    lessonsDaily: 0,
    support: 0,
    tutorsOnline: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounts({
        successRate: Math.min(counts.successRate + 1, 98),
        lessonsDaily: Math.min(counts.lessonsDaily + 250, 1000),
        support: Math.min(counts.support + 1, 24),
        tutorsOnline: Math.min(counts.tutorsOnline + 2, 50),
      });
    }, 50);
    return () => clearInterval(interval);
  }, [counts]);


  const features = [
    { image: jf, title: "Learn English" },
  { image: talk, title: "Bristu Talk" },
  { image: logo1, title: "Kerala PSC" },
  { image: tn, title: "Tamilnadu PSC" },
  
];

const menuItems = [
  { name: 'Home', href: '/' },
  // { name: 'About Us', id: 'about' },
  { 
    name: 'Courses',
    subItems: [
      { 
        name: 'Learn English', 
        onClick: (e) => {
          e.preventDefault(); 
          triggerLoginPopup(true); 
        }
      },
      { 
        name: 'Psc Prepration', 
        onClick: () => triggerLoginPopup(true) 
      }
    ]
  },
  { name: 'Book Store', href: '/books' },
  { name: 'Client Stories', id: 'clients' },
  { name: 'Contact', id: 'contact' }
];



const handleScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
    window.history.pushState({}, '', `#${id}`);
  }
};
const [courseList,setCourseList] = useState([]);
const fetchCourse = async() =>{
const ref = collection(db, "jaffers_english_courses");
const q = query(ref,orderBy("order","asc"),limit(3));
const querySnap = await getDocs(q);
const data = [];
querySnap.forEach((doc) => {
  data.push({ id: doc.id, ...doc.data() });
});
setCourseList(data);
}
useEffect(() => {
  fetchCourse();
}, []);
 const fetchVideos = async () => {
    const ref = collection(db, "home_page_videos");
    const q = query(ref, where("status", "==", true), orderBy("order", "asc"));
    const videosSnap = await getDocs(q);
    const data = [];
    videosSnap.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setVideoList(data);
  };
  useEffect(() => {
    fetchVideos();
  }, []);

  // ================== On Message Send ================== //
  const handleMessage = async (e) => {
    e.preventDefault();
    await addDoc(collection(db, "website_messages"), {
      ...messageContent,
    });
    setMessageContent({
      name: "",
      email: "",
      message: "",
      mobile: "",
    });
    setToastContent({
      type: "success",
      message: "Message sent successfully",
    });
  };
  
  return (
    <div>
      <nav className="bg-black/80 p-1 backdrop-blur-md border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16 items-center">
            <div className="flex-shrink-0 flex items-center">
              <a href="/" className="flex items-center gap-3">
                <img className="h-10 w-auto" src={logo} alt="BRISTU Logo" />
                <span className="text-white text-2xl font-bold tracking-tighter">
                  Bristu
                </span>
              </a>
            </div>

            <div className="hidden md:flex items-center space-x-6 flex-1 justify-center">
              {menuItems.map((item) =>
                item.subItems ? (
                  <div
                    key={item.name}
                    className="relative text-lg "
                    onMouseEnter={() => setOpenDropdown(item.name)}
                    onMouseLeave={() => setOpenDropdown(null)}
                    ref={dropdownRef}
                  >
                    <button className="text-gray-300 hover:text-emerald-400 px-3 py-2 text-sm font-medium flex items-center gap-1 transition-colors duration-200 group">
                      {item.name}
                      <svg
                        className={`w-4 h-4 transform transition-transform ${
                          openDropdown === item.name ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>

                    {openDropdown === item.name && (
                      <div className="absolute top-full left-0 bg-white/95 backdrop-blur-sm shadow-xl py-2 min-w-[200px] rounded-lg z-50 animate-fadeIn">
                        {item.subItems.map((subItem, index) => (
                          <a
                            key={index}
                            href={subItem.href || "#"}
                            onClick={subItem.onClick}
                            className="text-gray-800 hover:text-emerald-600 block px-4 py-2.5 text-sm transition-colors duration-200 hover:bg-gray-50/50"
                          >
                            {subItem.name}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    key={item.name}
                    href={item.href ? item.href : `#${item.id}`}
                    onClick={(e) => {
                      if (item.id) {
                        e.preventDefault();
                        handleScroll(item.id);
                      }
                    }}
                    className="text-gray-300 hover:text-emerald-400 px-3 py-2 text-sm font-medium transition-colors duration-200 relative group"
                  >
                    {item.name}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-400 transition-all duration-300 group-hover:w-full"></span>
                  </a>
                )
              )}
            </div>

            {/* Desktop Login */}
            <button
              onClick={() => triggerLoginPopup(true)}
              className="hidden md:flex items-center bg-emerald-700 border border-white/10 text-gray-100 px-8 py-2 rounded-full text-lg font-medium transition-all duration-200 hover:bg-emerald-500 hover:border-emerald-500 hover:text-white"
            >
              Login
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
            >
              <span className="sr-only">
                {isOpen ? "Close menu" : "Open menu"}
              </span>
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute w-full bg-black/95 backdrop-blur-sm border-b border-gray-800">
            <div className="px-4 pt-2 pb-6 space-y-1">
              {menuItems.map((item) =>
                item.subItems ? (
                  <div key={item.name} className="space-y-1">
                    <button
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === item.name ? null : item.name
                        )
                      }
                      className="w-full flex justify-between items-center px-4 py-3 text-gray-300 hover:bg-white/5 rounded-lg"
                    >
                      {item.name}
                      <svg
                        className={`w-4 h-4 transform transition-transform ${
                          openDropdown === item.name ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>

                    {openDropdown === item.name && (
                      <div className="pl-6 space-y-1">
                        {item.subItems.map((subItem, index) => (
                          <a
                            key={index}
                            href="/"
                            onClick={() => setIsOpen(false)}
                            className="block px-4 py-2.5 text-sm text-gray-400 hover:bg-white/5 rounded-lg"
                          >
                            {subItem}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    key={item.name}
                    href={item.href}
                    onClick={() => setIsOpen(false)}
                    className="block px-4 py-3 text-gray-300 hover:bg-white/5 rounded-lg transition-colors duration-200"
                  >
                    {item.name}
                  </a>
                )
              )}

              <button
                onClick={() => {
                  triggerLoginPopup(true);
                  setIsOpen(false);
                }}
                className="w-full mt-4 bg-emerald-600/80 hover:bg-emerald-500 px-6  text-gray-100 py-3 rounded-full text-sm font-medium transition-colors duration-200"
              >
                Login
              </button>
            </div>
          </div>
        )}
      </nav>

      <section className="relative  bg-black overflow-hidden ">
        <Toast
          type={toastContent.type}
          message={toastContent.message}
          onComplete={() => setToastContent({ type: "", message: "" })}
        />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            {/* Text Content */}
            <div className="lg:w-1/2 space-y-8 relative z-10 py-6">
              {/* Highlight Badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                className="inline-block bg-black border border-green-500 px-6 py-2  rounded-full text-sm font-semibold text-green-300 shadow-green-500/50 shadow-md mb-8"
              >
                🚀 New: AI-Powered Learning!
              </motion.div>

              {/* Title */}
              <h1 className="md:text-6xl text-5xl  sm:text-[2rem] lg:text-[4rem] font-bold text-gray-100 leading-tight">
                With Bristu, Every{" "}
                <span className="bg-gradient-to-r from-green-500 to-cyan-400 bg-clip-text text-transparent">
                  lesson is an adventure!
                </span>
              </h1>

              {/* Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-md text-gray-200 leading-relaxed"
              >
                Join <span className="font-bold text-green-300">50,000+</span>{" "}
                students mastering English through personalized lessons,
                interactive exercises, and real-world conversation practice.
              </motion.p>

              {/* Statistics Cards */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 my-12">
                {[
                  {
                    label: "Success Rate",
                    value: counts.successRate,
                    color: "text-green-400",
                  },
                  {
                    label: "Lessons Daily",
                    value: counts.lessonsDaily,
                    color: "text-cyan-400",
                  },
                  {
                    label: "Support",
                    value: counts.support,
                    color: "text-green-400",
                  },
                  {
                    label: "Tutors Online",
                    value: counts.tutorsOnline,
                    color: "text-cyan-400",
                  },
                ].map((stat, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 + i * 0.1 }}
                    whileHover={{ scale: 1.1 }}
                    className="text-center p-4 bg-black border border-gray-800 backdrop-blur-md rounded-xl shadow-lg transition-all hover:shadow-green-500/50"
                  >
                    <div className={`text-3xl font-bold ${stat.color}`}>
                      {stat.value}+
                    </div>
                    <div className="text-sm text-gray-400">{stat.label}</div>
                  </motion.div>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-1/2 relative group/section perspective-1000">
              {/* Main Image Container with Hover Enhancement */}
              <motion.div initial={false} whileHover="hover" className="w-full">
                <motion.img
                  src={img}
                  alt="Futuristic Learning Platform"
                  className="w-full h-auto object-cover"
                  variants={{
                    hover: { scale: 1.03 },
                  }}
                  transition={{ type: "spring", stiffness: 200 }}
                />
              </motion.div>

              {/* English Mastery Card - Circular Shape */}
              <motion.div
                className="absolute top-[10%] left-[1%] sm:top-[16%] sm:-left-2 animate-liveMic "
                initial={{ x: -200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 10,
                  delay: 0.2,
                }}
              >
                <motion.div
                  onClick={() => triggerLoginPopup(true)}
                  whileHover={{ y: -10, rotateZ: -5, scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="group/card relative bg-gradient-to-br from-emerald-600/30 to-emerald-800/20 backdrop-blur-lg p-1 rounded-full shadow-2xl border border-emerald-400/20 cursor-pointer hover:shadow-emerald-500/30 transition-all"
                >
                  <div className="w-32 h-32 sm:w-44 sm:h-44 flex flex-col items-center justify-center bg-gradient-to-tr from-emerald-800 to-emerald-900/90 rounded-full p-4 sm:p-6 relative overflow-hidden">
                    {/* Holographic Effect */}
                    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 mix-blend-overlay" />

                    {/* Icon Container */}
                    <motion.div
                      whileHover={{ scale: 1.15, rotate: 5 }}
                      className="p-2 sm:p-3 bg-emerald-500/90 rounded-full shadow-lg mb-2 sm:mb-4 transform-gpu"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        class="bi bi-book"
                        viewBox="0 0 16 16"
                      >
                        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                      </svg>
                    </motion.div>

                    {/* Text Content */}
                    <span className="text-xs sm:text-lg font-semibold bg-gradient-to-r from-emerald-300 to-emerald-100 bg-clip-text text-transparent">
                      Learn English
                    </span>
                    <span className="text-xs text-emerald-200/80 mt-1 ">
                      Start Learning
                    </span>
                    <span className="text-xs text-emerald-200/80 mt-1 ">
                      Login Now
                    </span>
                  </div>
                </motion.div>
              </motion.div>

              {/* PSC Preparation Card - Circular Shape */}
              <motion.div
                onClick={() => triggerLoginPopup(true)}
                className="absolute top-[25%] right-[1%] sm:top-[29s%] sm:-right-10 animate-liveMic"
                initial={{ x: 200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 10,
                  delay: 0.3,
                }}
              >
                <motion.div
                  whileHover={{ y: -10, rotateZ: 5, scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="group/card relative bg-gradient-to-bl from-purple-600/30 to-purple-800/20 backdrop-blur-lg p-1 rounded-full shadow-2xl border border-purple-400/20 cursor-pointer hover:shadow-purple-500/30 transition-all"
                >
                  <div className="w-32 h-32 sm:w-44 sm:h-44 flex flex-col items-center justify-center bg-gradient-to-tl from-purple-800 to-purple-900/90 rounded-full p-4 sm:p-6 relative overflow-hidden">
                    {/* Dynamic Grid Pattern */}
                    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/grid.png')] opacity-15 mix-blend-overlay" />

                    {/* Icon Container */}
                    <motion.div
                      whileHover={{ scale: 1.15, rotate: -5 }}
                      className="p-2 sm:p-3 bg-purple-500/90 rounded-full shadow-lg mb-2 sm:mb-4 transform-gpu"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        class="bi bi-book"
                        viewBox="0 0 16 16"
                      >
                        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                      </svg>
                    </motion.div>

                    {/* Text Content */}
                    <span className="text-xs text-center sm:text-md font-semibold bg-gradient-to-r from-purple-300 to-purple-100 bg-clip-text text-transparent">
                      PSC Preparation
                    </span>
                    <span className="text-xs text-purple-200/80 mt-1">
                      Start Learning
                    </span>
                    <span className="text-xs text-purple-200/80 mt-1 ">
                      Login Now
                    </span>
                  </div>

                  {/* Neon Glow Effect */}
                  <div className="absolute inset-0 rounded-full pointer-events-none border border-purple-400/10 mix-blend-screen" />
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="about"
        className="relative overflow-hidden py-24 bg-gradient-to-br from-black via-emerald-950 to-emerald-600"
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-10 md:px-12 relative z-10 text-center">
          <h1 className="text-4xl   sm:text-[2rem] font-extrabold bg-gradient-to-r from-green-500 to-cyan-400 bg-clip-text text-transparent">
            Why Choose Bristu?
          </h1>
          <div className="w-32 h-[1px] bg-lime-400 mt-4 mx-auto rounded-full shadow-lg shadow-lime-500/50"></div>
          <p className="text-lg text-gray-300 mt-6 leading-relaxed max-w-3xl mx-auto">
            Unlock the future of learning with AI-driven tutoring, interactive
            courses, and a thriving community built to elevate your skills.
          </p>
        </div>

        <div className=" max-w-7xl mx-auto  sm:px-10 md:px-6  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-16 px-4">
          {features.map((item, index) => (
            <motion.div
              onClick={() => triggerLoginPopup(true)}
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="relative p-10 rounded-3xl bg-gradient-to-br from-black via-emerald-900 to-emerald-700 border border-lime-400 backdrop-blur-xl shadow-2xl transition-all transform hover:scale-105 hover:border-lime-500 hover:shadow-green-400/50 hover:-translate-y-2"
            >
              {/* Floating Glow Effect */}
              <div className="absolute inset-0 bg-emerald-600 opacity-20 rounded-3xl blur-xl"></div>

          
              <img
                src={item.image}
                alt={item.title}
                className="w-28 h-20 object-contain mx-auto mb-6 drop-shadow-xl transition-transform duration-300 hover:scale-110"
              />

           
              <h3 className="text-xl font-semibold text-gray-100 text-center">
                {item.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="py-28  md:px-16 bg-black">
        <div className="max-w-7xl mx-auto text-center space-y-16">
          <div className="space-y-6">
            <h2 className="text-4xl font-extrabold text-center font-serif text-white mb-6">
              Our Courses
            </h2>
            <p className="text-gray-400 text-center py-4 font-serif text-lg max-w-4xl mx-auto">
              Master English with our AI-powered curriculum, interactive
              exercises, and personalized feedback system.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
            {courseList.map((course) => (
              <motion.div
                key={course.id}
                whileHover={{ y: -10 }}
                transition={{ type: "spring", stiffness: 300 }}
                className="group relative bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700/50 hover:border-cyan-400/30 transition-all duration-300 shadow-xl hover:shadow-2xl hover:shadow-cyan-400/10"
                onClick={() => triggerLoginPopup(true)}
              >
                <div className="p-6 space-y-4">
                  <div className="relative overflow-hidden rounded-xl h-48">
                    <img
                      src={course.img_url}
                      alt={course.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent" />
                    <div className="absolute top-4 right-4 flex items-center space-x-2 bg-slate-900/80 px-3 py-1 rounded-full">
                      <span className="text-sm font-medium text-cyan-400">
                        {course.level}
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3 text-left">
                    <div className="flex items-center justify-between">
                      <h3 className="text-xl font-bold text-slate-100">
                        {course.title.slice(0, 20)}
                      </h3>
                      <div className="flex items-center space-x-1 text-yellow-300">
                        <StarIcon className="h-3 w-3" />
                        <StarIcon className="h-3 w-3" />{" "}
                        <StarIcon className="h-3 w-3" />{" "}
                        <StarIcon className="h-3 w-3" />{" "}
                        <StarIcon className="h-3 w-3" />
                       
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-4">
                      <div className="flex items-center space-x-2">
                       
                        <span className="text-sm text-slate-400">
                          100+ students
                        </span>
                      </div>
                      <div className="bg-gradient-to-r from-cyan-500 to-emerald-600 px-4 py-2 rounded-full text-sm font-semibold text-white hover:shadow-lg hover:shadow-cyan-500/20 transition-all">
                        Enroll Now
                      </div>
                    </div>
                  </div>
                </div>

          
                <div className="absolute inset-0 overflow-hidden rounded-2xl">
                  <div className="absolute -inset-24 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(34,211,238,0.1),transparent)] animate-shine" />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Animated gradient border */}
          {/* <div className="absolute left-0 right-0 -bottom-px h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent opacity-20" /> */}
        </div>
      </section>

      <style jsx global>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      <div class="relative bg-gradient-to-br from-black via-emerald-950 to-emerald-600 py-24 overflow-hidden">
        <div class="max-w-7xl mx-auto px-6 relative z-10">
          <h2 class="text-4xl font-extrabold text-center font-serif text-white mb-6">
            Meet Our Faculty
          </h2>

          <p class="text-gray-400 text-center py-4 font-serif text-lg max-w-4xl mx-auto">
            Our team of experienced educators is dedicated to providing
            top-notch English learning guidance, helping students master
            phonetics, grammar, writing, and public speaking with confidence.
          </p>

          <div class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-8 text-center mt-12">
            <div class="p-6 rounded-lg transition-all duration-300 hover:shadow-2xl">
              <img
                alt="Faculty"
                src={imgg4}
                class="w-36 h-36 rounded-full mx-auto "
              />
              <div class="mt-4">
                <h4 class="text-white text-xl font-serif font-semibold">
                  JAFAR SADIK
                </h4>
                <p class="text-emerald-400 font-serif text-md mt-2">
                  Course Cordinator & Chief Educator
                </p>
              </div>
            </div>

            <div class="p-6 rounded-lg transition-all duration-300 hover:shadow-2xl">
              <img
                src={imgg3}
                alt="Faculty"
                class="w-36 h-36 rounded-full mx-auto "
              />
              <div class="mt-4">
                <h4 class="text-white text-xl font-serif font-semibold">
                  DANIEL
                </h4>
                <p class="text-emerald-400 text-md font-serif mt-2">
                  Chief Mentor
                </p>
              </div>
            </div>

            <div class="p-6 rounded-lg  transition-all duration-300 hover:shadow-2xl">
              <img
                src={imgg1}
                alt="Faculty"
                class="w-36 h-36 rounded-full mx-auto "
              />
              <div class="mt-4">
                <h4 class="text-white text-xl font-serif font-semibold">
                  MERSHIN
                </h4>
                <p class="text-emerald-400 text-md font-serif mt-2">
                  Kids Session- Chief Cordinator
                </p>
              </div>
            </div>

            <div class="p-6 rounded-lg transition-all duration-300 hover:shadow-2xl">
              <img
                src={imgg2}
                alt="Faculty"
                class="w-36 h-36 rounded-full mx-auto "
              />
              <div class="mt-4">
                <h4 class="text-white text-xl font-serif font-semibold">
                  SAFANA
                </h4>
                <p class="text-emerald-400 text-md font-serif mt-2">
                  Batch Organiser
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="relative bg-black py-6">
        <div
          className="max-w-7xl mx-auto px-6 sm:px-10 md:px-12 py-12"
          onMouseEnter={() => setAutoPlay(false)}
          onMouseLeave={() => setAutoPlay(true)}
        ></div>
        <div
          className="max-w-7xl mx-auto px-6 sm:px-10 md:px-12 py-12"
          onMouseEnter={() => setAutoPlay(false)}
          onMouseLeave={() => setAutoPlay(true)}
        >
          <div className="max-w-7xl mx-auto text-center relative z-10">
            <h1 className="text-4xl font-serif  md:text-3xl font-bold mb-4 bg-gradient-to-r from-blue-100 to-green-400 bg-clip-text text-transparent text-transparent">
              English Learning{" "}
              <span className="bg-clip-text text-transparent">
                {" "}
                Video Gallery{" "}
              </span>
            </h1>

            <p className="text-gray-100 text-base mt-8 font-serif  md:text-base">
              Explore a diverse collection of videos designed to enhance your
              English language journey.
            </p>
          </div>

          <div
            ref={scrollContainerRef}
            className="flex py-12 mt-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-8"
          >
            {videoList.map((video, index) => (
              <div
                key={video.id}
                ref={(el) => (itemsRef.current[index] = el)}
                className={`flex-shrink-0 w-4/5 md:w-1/2 lg:w-1/3 px-4 transition-transform duration-500 ${
                  index === activeIndex ? "scale-110" : "scale-90 opacity-85"
                }`}
              >
                <div
                  className="relative aspect-video rounded-2xl overflow-hidden shadow cursor-pointer"
                  onClick={() => handleThumbnailClick(video)}
                >
                  <img
                    src={video.thumbnail}
                    alt={"Inroduction"}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button className="p-3 bg-white/60 rounded-full backdrop-blur-sm hover:scale-110 transition-transform">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="33"
                        fill="#5EA331"
                        viewBox="0 0 16 16"
                      >
                        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {modalOpen && (
            <div className="fixed inset-0 bg-black/10 flex items-center justify-center z-50">
              <div className="relative w-full max-w-4xl bg-white rounded-lg shadow-lg">
                <button
                  className="absolute top-2 right-2 h-10 w-10 text-white bg-gray-600 rounded-full p-2"
                  onClick={() => setModalOpen(false)}
                >
                  X
                </button>
                <div className="aspect-video">
                  <ReactPlayer
                    controls={true}
                    width="100%"
                    height="100%"
                    playing
                    className="w-full h-full"
                    url={
                      "https://www.youtube.com/watch?v=" +
                      currentVideo?.video_url
                    }
                    allowFullScreen
                  ></ReactPlayer>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <section
        id="clients"
        className="py-16 bg-gradient-to-br from-black via-emerald-950 to-emerald-600 relative"
      >
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <h2 className="text-3xl font-serif font-bold bg-gradient-to-r from-blue-400 to-green-400 bg-clip-text text-transparent text-center mb-12">
            Student Success Stories
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                name: "Arun Raj",
                review:
                  "Bristu helped me improve my English fluency drastically. The interactive lessons and practice tests made learning easy!",
                rating: 5,
                role: "College Student",
              },
              {
                name: "Neha Menon",
                review:
                  "The structured learning approach at Bristu gave me confidence in my speaking skills. The support from tutors was excellent!",
                rating: 5,
                role: "IELTS Aspirant",
              },
              {
                name: "Rahul Krishnan",
                review:
                  "I struggled with grammar before joining Bristu. Their step-by-step courses helped me master it effortlessly.",
                rating: 4,
                role: "Graduate Student",
              },
              {
                name: "Divya Nair",
                review:
                  "The best platform for learning English! The practical exercises and live sessions made a big difference in my skills.",
                rating: 5,
                role: "Working Professional",
              },
              {
                name: "Vishnu Das",
                review:
                  "I used to be afraid of speaking in English, but Bristu's interactive training boosted my confidence.",
                rating: 4,
                role: "Job Seeker",
              },
            ].map((testimonial, index) => (
              <div
                key={index}
                className="bg-gray-900/30 p-6 rounded-lg border border-gray-800/50 shadow-lg hover:shadow-xl transition duration-300 backdrop-blur-sm"
              >
                <div className="mb-4 flex items-center">
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className={`w-5 h-5 ${
                          i < testimonial.rating
                            ? "text-yellow-400"
                            : "text-gray-700"
                        }`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.769 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>

                <p className="text-gray-300 font-serif mb-4">
                  "{testimonial.review}"
                </p>

                <div className="flex items-center">
                  <img
                    src={`https://ui-avatars.com/api/?name=${testimonial.name.replace(
                      " ",
                      "+"
                    )}&background=random`}
                    alt={`Student ${testimonial.name}`}
                    className="w-12 h-12 rounded-full mr-4 border-2 border-emerald-500"
                  />
                  <div>
                    <h4 className="font-semibold text-white">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-400 text-sm">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" class="bg-black py-12">
        <div class=" max-w-7xl mx-auto p-4">
          <div class=" ">
            <h1 class="text-2xl font-serif  bg-gradient-to-r from-blue-500 to-green-500 bg-clip-text text-transparent font-bold text-center mt-6">
              We'd Love to Hear from You – Reach Out to Us Anytime!
            </h1>
            <form
              onSubmit={handleMessage}
              class="space-y-6 max-w-2xl py-12 mx-auto text-gray-800"
            >
              <input
                type="text"
                placeholder="Name"
                onChange={(e) => {
                  setMessageContent({
                    ...messageContent,
                    name: e.target.value,
                  });
                }}
                value={messageContent.name}
                required
                class="w-full border py-2.5 px-4 rounded-lg  text-sm focus:border-[#5EA331] outline-none"
              />
              <input
                type="email"
                placeholder="Email"
                required
                onChange={(e) => {
                  setMessageContent({
                    ...messageContent,
                    email: e.target.value,
                  });
                }}
                value={messageContent.email}
                class="w-full border py-2.5 px-4 rounded-lg  text-sm focus:border-[#5EA331] outline-none"
              />
              <input
                type="number"
                required
                value={messageContent.mobile}
                onChange={(e) => {
                  setMessageContent({
                    ...messageContent,
                    mobile: e.target.value,
                  });
                }}
                placeholder="Phone No."
                class="w-full border py-2.5 px-4 rounded-lg text-sm focus:border-[#5EA331] outline-none"
              />
              <textarea
                placeholder="Message"
                required
                rows="6"
                value={messageContent.message}
                onChange={(e) => {
                  setMessageContent({
                    ...messageContent,
                    message: e.target.value,
                  });
                }}
                class="w-full border px-4 rounded-lg mt-2 text-sm pt-3 focus:border-[#5EA331] outline-none"
              ></textarea>
              <button
                type="submit"
                class="text-white w-full border bg-black  text-sm px-4 py-4 !mt-6"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16px"
                  height="16px"
                  fill="currentColor"
                  class="mr-2 inline"
                  viewBox="0 0 548.244 548.244"
                >
                  <path
                    fill-rule="evenodd"
                    d="M392.19 156.054 211.268 281.667 22.032 218.58C8.823 214.168-.076 201.775 0 187.852c.077-13.923 9.078-26.24 22.338-30.498L506.15 1.549c11.5-3.697 24.123-.663 32.666 7.88 8.542 8.543 11.577 21.165 7.879 32.666L390.89 525.906c-4.258 13.26-16.575 22.261-30.498 22.338-13.923.076-26.316-8.823-30.728-22.032l-63.393-190.153z"
                    clip-rule="evenodd"
                    data-original="#000000"
                  />
                </svg>
                Send Message
              </button>
            </form>

            <div class="grid grid-cols-2 lg:grid-cols-4 gap-12 py-6 mt-12">
              <div class="flex flex-col items-center bg-black">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 fill-emerald-700"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M341.476 338.285c54.483-85.493 47.634-74.827 49.204-77.056C410.516 233.251 421 200.322 421 166 421 74.98 347.139 0 256 0 165.158 0 91 74.832 91 166c0 34.3 10.704 68.091 31.19 96.446l48.332 75.84C118.847 346.227 31 369.892 31 422c0 18.995 12.398 46.065 71.462 67.159C143.704 503.888 198.231 512 256 512c108.025 0 225-30.472 225-90 0-52.117-87.744-75.757-139.524-83.715zm-194.227-92.34a15.57 15.57 0 0 0-.517-.758C129.685 221.735 121 193.941 121 166c0-75.018 60.406-136 135-136 74.439 0 135 61.009 135 136 0 27.986-8.521 54.837-24.646 77.671-1.445 1.906 6.094-9.806-110.354 172.918L147.249 245.945zM256 482c-117.994 0-195-34.683-195-60 0-17.016 39.568-44.995 127.248-55.901l55.102 86.463a14.998 14.998 0 0 0 25.298 0l55.101-86.463C411.431 377.005 451 404.984 451 422c0 25.102-76.313 60-195 60z"
                    data-original="#000000"
                  ></path>
                  <path
                    d="M256 91c-41.355 0-75 33.645-75 75s33.645 75 75 75 75-33.645 75-75-33.645-75-75-75zm0 120c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z"
                    data-original="#000000"
                  ></path>
                </svg>
                <div class="mt-4 text-center">
                  <h4 class="text-gray-300 text-sm font-bold">Visit office</h4>
                  <p class="text-xs text-gray-200 mt-1">
                    {" "}
                    Palckal Archade, Cheeral Post, Sulthan Bathery,673595
                  </p>
                </div>
              </div>

              <div class="flex flex-col items-center bg-black">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 fill-emerald-700"
                  viewBox="0 0 473.806 473.806"
                >
                  <path
                    d="M374.456 293.506c-9.7-10.1-21.4-15.5-33.8-15.5-12.3 0-24.1 5.3-34.2 15.4l-31.6 31.5c-2.6-1.4-5.2-2.7-7.7-4-3.6-1.8-7-3.5-9.9-5.3-29.6-18.8-56.5-43.3-82.3-75-12.5-15.8-20.9-29.1-27-42.6 8.2-7.5 15.8-15.3 23.2-22.8 2.8-2.8 5.6-5.7 8.4-8.5 21-21 21-48.2 0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5-6-6.2-12.3-12.6-18.8-18.6-9.7-9.6-21.3-14.7-33.5-14.7s-24 5.1-34 14.7l-.2.2-34 34.3c-12.8 12.8-20.1 28.4-21.7 46.5-2.4 29.2 6.2 56.4 12.8 74.2 16.2 43.7 40.4 84.2 76.5 127.6 43.8 52.3 96.5 93.6 156.7 122.7 23 10.9 53.7 23.8 88 26 2.1.1 4.3.2 6.3.2 23.1 0 42.5-8.3 57.7-24.8.1-.2.3-.3.4-.5 5.2-6.3 11.2-12 17.5-18.1 4.3-4.1 8.7-8.4 13-12.9 9.9-10.3 15.1-22.3 15.1-34.6 0-12.4-5.3-24.3-15.4-34.3l-54.9-55.1zm35.8 105.3c-.1 0-.1.1 0 0-3.9 4.2-7.9 8-12.2 12.2-6.5 6.2-13.1 12.7-19.3 20-10.1 10.8-22 15.9-37.6 15.9-1.5 0-3.1 0-4.6-.1-29.7-1.9-57.3-13.5-78-23.4-56.6-27.4-106.3-66.3-147.6-115.6-34.1-41.1-56.9-79.1-72-119.9-9.3-24.9-12.7-44.3-11.2-62.6 1-11.7 5.5-21.4 13.8-29.7l34.1-34.1c4.9-4.6 10.1-7.1 15.2-7.1 6.3 0 11.4 3.8 14.6 7l.3.3c6.1 5.7 11.9 11.6 18 17.9 3.1 3.2 6.3 6.4 9.5 9.7l27.3 27.3c10.6 10.6 10.6 20.4 0 31-2.9 2.9-5.7 5.8-8.6 8.6-8.4 8.6-16.4 16.6-25.1 24.4-.2.2-.4.3-.5.5-8.6 8.6-7 17-5.2 22.7l.3.9c7.1 17.2 17.1 33.4 32.3 52.7l.1.1c27.6 34 56.7 60.5 88.8 80.8 4.1 2.6 8.3 4.7 12.3 6.7 3.6 1.8 7 3.5 9.9 5.3.4.2.8.5 1.2.7 3.4 1.7 6.6 2.5 9.9 2.5 8.3 0 13.5-5.2 15.2-6.9l34.2-34.2c3.4-3.4 8.8-7.5 15.1-7.5 6.2 0 11.3 3.9 14.4 7.3l.2.2 55.1 55.1c10.3 10.2 10.3 20.7.1 31.3zm-154.2-286.1c26.2 4.4 50 16.8 69 35.8s31.3 42.8 35.8 69c1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.4-1.2 12.3-8.2 11.1-15.6-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3 3.7-15.6 11s3.5 14.4 10.9 15.6zm217.2 96.3c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2 3.7-15.5 11-1.2 7.4 3.7 14.3 11.1 15.6 46.6 7.9 89.1 30 122.9 63.7 33.8 33.8 55.8 76.3 63.7 122.9 1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.3-1.1 12.3-8.1 11-15.4z"
                    data-original="#000000"
                  ></path>
                </svg>
                <div class="mt-4 text-center">
                  <h4 class="text-gray-300 text-sm font-bold">Call us</h4>
                  <p class="text-xs text-gray-300 mt-1"> 9495759782</p>
                </div>
              </div>
              <div class="flex flex-col items-center bg-black">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 fill-emerald-700"
                  viewBox="0 0 32 32"
                >
                  <path
                    d="M8 30a1.001 1.001 0 0 1-1-1v-5H4c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h24c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3H15.851l-7.226 5.781A.998.998 0 0 1 8 30zM4 4c-.552 0-1 .449-1 1v16c0 .551.448 1 1 1h4a1 1 0 0 1 1 1v3.92l5.875-4.701A1 1 0 0 1 15.5 22H28c.552 0 1-.449 1-1V5c0-.551-.448-1-1-1z"
                    data-original="#000000"
                  ></path>
                  <path
                    d="M24 12H8a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm-8 4H8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2z"
                    data-original="#000000"
                  ></path>
                </svg>
                <div class="mt-4 text-center">
                  <h4 class="text-gray-300 text-sm font-bold">Chat to us</h4>
                  <p class="text-xs text-gray-300 mt-1">
                    {" "}
                    bristuappofficial@gmail.com
                  </p>
                </div>
              </div>

              <div class="flex flex-col items-center bg-black">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 fill-emerald-700"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M83 23h-3V11c0-3.309-2.692-6-6-6H26c-3.308 0-6 2.691-6 6v12h-3C8.729 23 2 29.729 2 38v30c0 4.963 4.037 9 9 9h9v12c0 3.309 2.692 6 6 6h48c3.308 0 6-2.691 6-6V77h9c4.963 0 9-4.037 9-9V38c0-8.271-6.729-15-15-15zM26 11h48v12H26zm0 78V59h48v30zm66-21c0 1.654-1.345 3-3 3h-9V59h3a3 3 0 1 0 0-6H17a3 3 0 1 0 0 6h3v12h-9c-1.655 0-3-1.346-3-3V38c0-4.963 4.037-9 9-9h66c4.963 0 9 4.037 9 9zm-27 0a3 3 0 0 1-3 3H38a3 3 0 1 1 0-6h24a3 3 0 0 1 3 3zm0 12a3 3 0 0 1-3 3H38a3 3 0 1 1 0-6h24a3 3 0 0 1 3 3zm21-42a3 3 0 0 1-3 3h-6a3 3 0 1 1 0-6h6a3 3 0 0 1 3 3z"
                    data-original="#000000"
                  ></path>
                </svg>
                <div class="mt-4 text-center">
                  <h4 class="text-gray-300 text-sm font-bold">Whatsapp</h4>
                  <p class="text-xs text-gray-200 mt-1">9495759782</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    <div className="fixed bottom-6 right-6 z-50">
      <a
        href="https://wa.me/919495759782"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-16 h-16 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="w-8 h-8" />
        
        {/* Modern tooltip */}
        <div className="absolute right-full mr-3 px-3 py-2 bg-gray-800 text-white text-sm font-medium rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-md">
          Chat with us
          <div className="absolute top-1/2 right-0 w-2 h-2 bg-gray-800 transform translate-x-1/2 -translate-y-1/2 rotate-45"></div>
        </div>
        
        {/* Ping animation (optional) */}
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-ping opacity-75"></span>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
      </a>
    </div>



      <footer className="bg-black text-white">
        {/* Top Divider */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-800"></div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand Section */}
            <div className="space-y-4">
              <div className="flex items-center">
                <img src="/logo.png" alt="Logo" className="h-10 w-auto" />
                <span className="ml-3 text-xl font-semibold">BRISTU</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
                "Empowering Automotive Professionals with Top-Tier Training & Resources."
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h5 className="text-lg font-semibold mb-4 relative pb-2 after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-emerald-700">
                Quick Links
              </h5>
              <ul className="space-y-2">
                {[
                  { name: "Home", href: "/" },
                  { name: "About", href: "/about" },
                  { name: "Courses", id: "courses-section" },
                ].map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href || `#${item.id}`}
                      onClick={(e) => {
                        if (item.id) {
                          e.preventDefault();
                          handleScroll(item.id);
                        }
                      }}
                      className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center group text-sm"
                    >
                      <svg className="w-4 h-4 mr-2 text-emerald-500 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h5 className="text-lg font-semibold mb-4 relative pb-2 after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-emerald-700">
                Quick Links
              </h5>
              <ul className="space-y-2">
                {[
                  { name: "Book Store", id: "bookstore-section" },
                  { name: "Client Stories", id: "clients" },
                  { name: "Contact", id: "contact" },
                ].map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href || `#${item.id}`}
                      onClick={(e) => {
                        if (item.id) {
                          e.preventDefault();
                          handleScroll(item.id);
                        }
                      }}
                      className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center group text-sm"
                    >
                      <svg className="w-4 h-4 mr-2 text-emerald-500 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal & Policies */}
            <div>
              <h5 className="text-lg font-semibold mb-4 relative pb-2 after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-emerald-700">
                Legal & Policies
              </h5>
              <ul className="space-y-2">
                {[
                  { name: "Terms & Conditions", href: "/terms" },
                  { name: "Privacy Policy", href: "/privacy" },
                  { name: "Cancellation & Refund", href: "/refund" },
                  { name: "Shipping & Exchange", href: "/shipping" },
                ].map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center group text-sm"
                    >
                      <svg className="w-4 h-4 mr-2 text-emerald-500 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          

          {/* Copyright Section */}
        
        </div>

          <div className="mt-4 pt-8 border-t border-gray-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-400 text-sm">
                © {new Date().getFullYear()} BRISTU EDUCATION PRIVATE LIMITED. All rights reserved.
              </div>
              <div className="flex items-center space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-gray-400 text-sm">bristuappofficial@gmail.com</span>
              </div>
            </div>
          </div>
          </div>

        <div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-800"></div>
          </div>
          
        </div>
        
      </footer>
    </div>
  );
};

export default Navbar;
